import { render, staticRenderFns } from "./Pad.vue?vue&type=template&id=75526120"
import script from "./Pad.vue?vue&type=script&lang=ts"
export * from "./Pad.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports